/*
  Nasconde la bolla della chat Tidio mentre il carrello laterale è aperto e la rimostra alla chiusura,
  così non copre il pulsante del checkout (soprattutto su telefono).
  Il cassetto del tema (<cart-drawer>) aggiunge la classe "active" quando si apre.
  La bolla torna visibile solo se l'abbiamo nascosta noi: le impostazioni di Tidio restano valide.
  Davide | SEO Specialist di Wider View
*/
(() => {
	const drawer = document.querySelector('cart-drawer');
	if (!drawer) return;

	let nascostaDaNoi = false;

	const sync = () => {
		const api = window.tidioChatApi;
		if (!api) return;
		if (drawer.classList.contains('active')) {
			if (!nascostaDaNoi) {
				api.hide();
				nascostaDaNoi = true;
			}
		} else if (nascostaDaNoi) {
			api.show();
			nascostaDaNoi = false;
		}
	};

	new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
	// Tidio si carica dopo il tema: se il carrello era già aperto, allinea appena la chat è pronta
	document.addEventListener('tidioChat-ready', sync);
})();
